import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import {
  MemberQuery,
  RegistrationAnswerModel,
  RegistrationQuestionAnswerModel,
  RegistrationQuestionType,
  UserQuestionAnswerModel,
  UserQuestionsQuery,
  UserQuestionsService,
} from '@fgb/core';
import { tap } from 'rxjs/operators';

type QuestionAndAnswer = {
  answerForm: any;
  question: Question;
};
type Question = {
  value: string;
  type: RegistrationQuestionType;
};
@Component({
  selector: 'fgbcl-edit-questions',
  templateUrl: './edit-questions.component.html',
  styleUrls: ['./edit-questions.component.scss'],
})
export class EditQuestionsComponent implements OnInit {
  /** comfortEdit is a status use for Edit question logic
   * In this state, if the value is blank then the user should be able to edit it, but once it has value in it, there should be no edit button visible.
   * Similarly, if there are 2 questions and 1 is blank then the edit button should appear but only the blank answer should be editable.
   */
  @Input() comfortEdit: boolean = false;
  questionAnswerArr: QuestionAndAnswer[] = [];
  registrationQuestionAnswerModel: RegistrationQuestionAnswerModel[];
  toggleEdit: boolean = false;
  isEditable: boolean = true;
  constructor(
    private userQuestionService: UserQuestionsService,
    private userQuestionQuery: UserQuestionsQuery,
    private fb: UntypedFormBuilder,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit(): void {
    this.userQuestionService.fetchQuestions().toPromise();
    this.userQuestionQuery
      .selectUserQuestion()
      .pipe(
        tap((response) => {
          this.registrationQuestionAnswerModel = [...response];
          this.initUserQuestionForm(response);
          if (this.comfortEdit) this.checkEditable();
        })
      )
      .toPromise();
  }
  /**Create an array with question and array formcontrol answer*/
  initUserQuestionForm(questionForm: RegistrationQuestionAnswerModel[]) {
    this.questionAnswerArr = [];
    if (!questionForm) return;
    questionForm.forEach((qf) => {
      this.questionAnswerArr.push({
        question: { value: qf.Question.Question, type: qf.Question.QuestionType },
        answerForm: this.fb.group({ arr: this.drawFormControl(qf.Answer) }),
      });
    });
  }

  /** Create formcontrol of answer and disabled it */
  drawFormControl(answers: RegistrationAnswerModel[]) {
    if (!answers) return;
    let formArr = this.fb.array(
      answers.map((answer) =>
        this.fb.control({
          Id: answer.Id,
          QuestionId: answer.QuestionId,
          Answer: answer.Answer ? answer.Answer : '',
          AnswerType: answer.AnswerType,
          Selected: answer.Selected,
        })
      )
    );
    formArr.disable();
    return formArr;
  }
  /*Run when user Click Edit button
   * Change state enable or disable all the answers */
  changeToggleEditValue(isCancel: boolean = false) {
    this.toggleEdit = !this.toggleEdit;
    this.toggleEdit && this.questionAnswerArr.forEach((qa) => qa.answerForm.controls['arr'].enable());
    !this.toggleEdit && this.questionAnswerArr.forEach((qa) => qa.answerForm.controls['arr'].disable());
    // /**change to Editable state */
    // if (this.toggleEdit === true) {
    //   if (this.comfortEdit) {
    //     this.questionAnswerArr.forEach((qa) => qa.answerForm.controls['arr'].enable());
    //   } else {
    //     this.questionAnswerArr.forEach((qa) => {
    //       if (qa.question.type === RegistrationQuestionType.TextBox) {
    //         if (qa.answerForm.controls['arr'].value[0].Answer == '') qa.answerForm.controls['arr'].enable();
    //       } else {
    //         /**In all answers of the question, if there no answer yet, enable that question to edit ( base on Selected field, Selected = true which mean answered) */
    //         let answersHasSelectedArr = qa.answerForm.controls['arr'].value.filter(
    //           (val: RegistrationAnswerModel) => val.Selected == true
    //         );
    //         !answersHasSelectedArr.length && qa.answerForm.controls['arr'].enable();
    //       }
    //     });
    //   }
    // }
    // /**change to Un-Editable state */
    // if (this.toggleEdit === false) {
    //   /**Click cancel button and return all data to init state */
    //   isCancel && this.initUserQuestionForm(this.registrationQuestionAnswerModel);
    //   this.questionAnswerArr.forEach((qa) => qa.answerForm.controls['arr'].disable());
    // }
    if (this.comfortEdit) this.checkEditable();
  }

  /**
   * Check all answers if there have one or more question not answer yet, appear buttons
   */
  checkEditable() {
    this.isEditable = false;
    this.questionAnswerArr?.forEach((qa) => {
      let answers = qa.answerForm.controls['arr'].value;
      if (qa.question.type === RegistrationQuestionType.TextBox) {
        /**If question type is Text box and there haven't answer yet, show buttons */
        if (answers[0].Answer === '') this.isEditable = true;
      } else {
        /**Get answers which is not selected */
        let answersNotSelected = answers.filter(
          (val: RegistrationAnswerModel) => val.Selected == false
        ) as Array<RegistrationAnswerModel>;
        /** if the total number of answers have not selected (answersNotSelected) equal to answers length, show button*/
        if (answersNotSelected.length === answers.length) this.isEditable = true;
      }
    });
    return;
  }

  /**When the answer change set true Selected property and set false to others in that question
   * @param indexQuestionAnswer index of question that user answered in array question
   * @param event event of changes input
   * @type type of question
   */
  onAnswerChange(indexQuestionAnswer: number, event: any, typeQuestion: number) {
    //Index of the current answer that user clicked
    let indexAnswer: number = 0;
    switch (typeQuestion) {
      case this.TYPE_QUESTION.DropDown:
        indexAnswer = event.target.selectedIndex - 1;
        break;
      case this.TYPE_QUESTION.Radio:
      case this.TYPE_QUESTION.MultiSelect:
      case this.TYPE_QUESTION.TextBox:
        indexAnswer = event.target.id;
        break;
    }
    //Get the array controls answer in questionAnswerArr
    const answerArrayControls = this.questionAnswerArr[indexQuestionAnswer].answerForm.controls['arr'].controls;
    //Get the form control of answer that user selected
    let formControlAnswer = answerArrayControls[indexAnswer];
    if (typeQuestion === this.TYPE_QUESTION.MultiSelect) {
      answerArrayControls[indexAnswer].patchValue({
        ...formControlAnswer.value,
        Selected: event.target.checked,
      });
    }
    //Set selected property equal TRUE and answer value of user answered in current question to the formcontrol
    if (typeQuestion === this.TYPE_QUESTION.TextBox) {
      answerArrayControls[indexAnswer].patchValue({
        ...formControlAnswer.value,
        Answer: event.target.value,
        Selected: true,
      });
    }
    if (typeQuestion === this.TYPE_QUESTION.DropDown || typeQuestion === this.TYPE_QUESTION.Radio) {
      answerArrayControls[indexAnswer].patchValue({
        ...formControlAnswer.value,
        Selected: true,
      });
      // Check on type DROPDOWN and RADIO if user not answer, set selected = false of others answer in that question
      answerArrayControls.forEach((control: any) => {
        if (control !== formControlAnswer) control.patchValue({ ...control.value, Selected: false });
      });
    }
  }

  /**Get all Answers has selected property equal TRUE then return all selected answer*/
  getArrayAnswerSelected(answerForms: Array<any>): RegistrationAnswerModel[] {
    let selectedAnswers: RegistrationAnswerModel[] = [];
    answerForms.forEach((question: RegistrationAnswerModel[]) => {
      question
        .filter((answer) => answer.Selected)
        .forEach((answer) => {
          selectedAnswers.push(answer);
        });
    });

    return selectedAnswers;
  }

  /**Run when user click Save button
   * Save the data to server
   */
  onSave() {
    const clubId = this.memberQuery.getClubId();
    const portalId = this.memberQuery.getPortalId();
    const answerFormValues = this.questionAnswerArr.map((qa) => qa.answerForm.value.arr);
    let arrAnswerSelected = this.getArrayAnswerSelected(answerFormValues);
    let answerBody = arrAnswerSelected.map((ans) => new UserQuestionAnswerModel(ans, clubId, portalId));
    this.userQuestionService.updateAnswers(answerBody);
    this.changeToggleEditValue();
  }

  get TYPE_QUESTION(): typeof RegistrationQuestionType {
    return RegistrationQuestionType;
  }
}
